import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=5698c0a0"
import script from "./Grid.vue?vue&type=script&lang=js"
export * from "./Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5698c0a0')) {
      api.createRecord('5698c0a0', component.options)
    } else {
      api.reload('5698c0a0', component.options)
    }
    module.hot.accept("./Grid.vue?vue&type=template&id=5698c0a0", function () {
      api.rerender('5698c0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Grid.vue"
export default component.exports